<template>
  <div id="app" ref="app" v-bind:class="{ 'no-bg-image': backgroundType === 'blank', 'onboarding-guide': backgroundType == 'onboarding_guide'}">
    <router-view/>
  </div>
</template>
<script>
import { BACKGROUND_COLOR } from './utils/backgroundType'
import { ApplicationState } from './application-state'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    data: function () {
        return {
            backgroundType: BACKGROUND_COLOR.BLUE_IMAGE
        }
    },
    computed: {
        activeUserDevice () {
            try {
                return this.$store.state.metadata.userData.activeUserDevice
            } catch (error) {}
            return false
        },
        appState () {
            return this.$store.state.appState
        }
    },
    methods: {
        async fetchServerTime () {
            try {
                // fetch current time and save time difference in store
                // add random param to timeServiceUrl to solve browser cache issue
                let timeServiceUrl = 'https://worldtimeapi.org/api/timezone/Europe/Berlin?' + Math.random()
                let resp = await this.$http.get(timeServiceUrl)
                let timeDiff = Math.floor(new Date() / 1000) - resp.data.unixtime
                this.$store.commit('setTimeDiff', timeDiff)
            } catch (err) {
                this.$store.commit('setTimeDiff', 0)
                console.log(err)
            }
        }
    },
    mounted: async function () {
        await this.fetchServerTime()
        setInterval(() => {
            this.$store.commit('intervalCounter')
        }, 1000)
        try {
            let user = firebase.auth().currentUser
            this.$store.commit('setUser', user)
            this.$db.metadata.watchActiveDeviceToken()
        } catch (error) {
            console.error(error)
        }
    },
    watch: {
        $route (newPage, beforePage) {
            try {
                if (newPage.meta.background) {
                    this.backgroundType = newPage.meta.background
                    return
                }
            } catch (error) { }
            this.backgroundType = BACKGROUND_COLOR.BLUE_IMAGE
        },
        activeUserDevice (newDevice, oldDevice) {
            try {
                if (this.appState !== ApplicationState.LOADING_DATA) {
                    let currentDeviceToken = this.$store.state.user.refreshToken
                    if (newDevice !== currentDeviceToken) {
                        this.$router.replace('/uredaj-obavijest')
                    }
                }
            } catch (error) {
                console.error(error)
            }
        }
    }
}
</script>
<style lang="scss">
@import "./styles/global.scss";

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
#nav {
    padding: 30px;
    a {
        font-weight: bold;
        color: #2c3e50;
        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
